import { render, staticRenderFns } from "./RegisterComponent.vue?vue&type=template&id=45384764&scoped=true"
import script from "./RegisterComponent.vue?vue&type=script&lang=js"
export * from "./RegisterComponent.vue?vue&type=script&lang=js"
import style0 from "./RegisterComponent.vue?vue&type=style&index=0&id=45384764&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45384764",
  null
  
)

export default component.exports